import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=14c253f0&scoped=true&"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordView.vue?vue&type=style&index=0&id=14c253f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c253f0",
  null
  
)

export default component.exports